import { Component, OnDestroy, OnInit } from '@angular/core';
import { IndividualService } from 'pac-api';
import { BehaviorSubject, combineLatest, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';

import { LoggerService } from '../logger.service';
import { MailingListService } from '../mailing-list.service';
import { WizardStep } from '../wizard-step';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';
import { WizardService } from '../wizard/wizard.service';
import { DemographicsNote } from './demographic-form';

@Component({
  selector: 'app-prospect-demographics',
  templateUrl: './prospect-demographics.component.html',
  styleUrls: ['./prospect-demographics.component.less']
})
export class ProspectDemographicsComponent implements OnInit, OnDestroy, WizardStep {
  static readonly Name = 'ProspectDemographicsComponent';
  readonly Name = 'ProspectDemographicsComponent';

  private subsink: SubSink = new SubSink();

  public Busy$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public ShouldShow$: Observable<boolean>;

  constructor(public wizard: WizardService,
    private navigation: WizardNavigationService,
    private individual: IndividualService,
    private mailingList: MailingListService,
    private logger: LoggerService) { }

  ngOnInit(): void {
    if (!this.wizard.HasProspectType) {
      this.logger.warn("Skipping Prospect Demographics since there's no prospect type")
      this.navigation.skip(this);
    }

    this.ShouldShow$ = this.mailingList.GetMailingListDetails('Drupal Role').pipe(
      map(result => {
        if (result.find(ml => ml.mls_name === 'Instructor Prospect')) {
          this.navigation.skip(this);
          return false;
        }

        return true;
      }),
      shareReplay(1)
    );
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  ready(): boolean {
    return true;
  }

  SaveData(data: { Note: DemographicsNote, MailingList: string }) {
    this.Busy$.next(true);

    this.subsink.sink = combineLatest([
      this.individual.AddNote({ not_subject: data.Note.Subject, not_note: data.Note.Note }),
      this.mailingList.GetMailingLists('Drupal Role').pipe(
        switchMap(result => {
          const list = result.find(mls => mls.mls_name === data.MailingList);
          if (list) {
            return this.mailingList.AddMailingListDetails(list);
          } else {
            return of(null);
          }
        })
      )
    ]).subscribe(
      ([noteResult, mlResult]) => {
        this.wizard.SyncIndividual().subscribe(ind => {
          this.navigation.next(this);
        });
      },
      error => {
        if (error.code && error.code == "invalid-subject") {
          this.navigation.next(this);
        } else {
          this.logger.error(error);
          this.navigation.next(this);
        }
      });
  }
}
